import React from 'react';
import s from './BlockFriends.module.css';
 

const BlockFriends = () => {
    return (
        <div className={s.friendBlock}>
            <div className={s.titleFriends}>Friends</div>
            <div>
                
            </div>
        </div>
    )
}

export default BlockFriends;